export default __webpack_public_path__ + "static/media/1601.cd799285.png";